import http from '@/http'

export function index() {
  return http.get('')
}